import styled from "styled-components";
import { Link } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import InputWithLabel from "components/forms/InputWithLabel";
import InputText from "components/forms/InputText";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import SmallSpinner from "components/other/SmallSpinner";
import RollingBox from "components/other/RollingBox";
import SponsoredMessage from "components/posts/SponsoredMessage";
import ButtonPrimarySmallIcon from "components/buttons/ButtonPrimarySmallIcon";
import SponsoredMessageListBox from "./SponsoredMessageListBox";
import ModalWrap from "components/other/ModalWrap";
import Backdrop from "components/other/Backdrop";
import ModalWindow from "components/other/ModalWindow";
import ButtonWhite from "components/buttons/ButtonWhite";

import sponsoredMessagesIcon from "assets/img/icons/icons8-message.svg";
import newTabIcon from "assets/img/icons/Expand-Window.svg";
import plusIcon from "assets/img/icons/plus-sign.svg";
import plusWhiteIcon from "assets/img/icons/plus-sign-white.svg";

const SponsoredMessages = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const TitleIcon = styled.div`
  display: inline-block;
  padding-right: 6px;

  transform: translateY(4.5px);

  width: 26px;
  min-width: 26px;
`;

const Text = styled.div`
  line-height: 130%;
`;

const LearnMoreLinkWrap = styled(Link)`
  display: inline-block;

  text-decoration: none;
  color: ${css.LIGHT_BLUE};
`;

const NewTabIcon = styled.div`
  padding-left: 3px;
  width: 11px;
  min-width: 11px;
  transform: translateY(1px);

  display: inline-block;
`;

const MessageForm = styled.div`
  display: flex;
  flex-direction: column;
`;

const PreviewWrap = styled.div`
  display: flex;
  align-items: flex-start;
`;

const DataLength = styled.div`
  font-size: 15px;
`;

const SubmitButton = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_LARGE};
  margin-bottom: 6px;

  display: flex;
`;

const Warning = styled.div`
  margin-top: 7px;

  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};
`;

const Messages = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const ListTitle = styled.div`
  font-weight: 500;
`;

const MessageList = styled.div`
  margin-bottom: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const CreateFormButton = styled.div`
  display: flex;
`;

const ConfirmDelete = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: auto;
  transform: translateX(-50%) translateY(-50%);

  width: 100%;
  max-width: 442px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: 200;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 100%;
  }
`;

const ConfirmDeleteWrap = styled.div`
  margin-top: 60px;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ConfirmDeleteText = styled.div``;

const ConfirmDeleteButtons = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_XLARGE};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${css.BUTTONS_GAP};
`;

const AdPlanWarning = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: ${css.ERROR_RED};

  transform: translateY(-10px);
`;

const Counter = ({ characters, max }) => {
  return (
    <DataLength>
      {characters}/{max}
    </DataLength>
  );
};

export default ({
  data,
  messageInputs,
  handleInputChange,
  warnings,
  profileData,
  textMaxLength,
  linkTextMaxLength,
  submitLoading,
  onMessageSubmit,
  submitError,
  messageForm,
  toggleMessageForm,
  onSwitchClick,
  switchLoading,
  onEditClick,
  onDeleteClick,
  loadingDelete,
  messageToDelete,
  closeDeleteModal,
  onConfirmDelete,
  editMessageModal,
  closeEditMessageModal,
  errorMessage,
}) => {
  const list = data.sponsoredMessages.map((message) => {
    return (
      <SponsoredMessageListBox
        key={message.id}
        message={message}
        onSwitchClick={onSwitchClick}
        switchLoading={switchLoading}
        onEditClick={onEditClick}
        onDeleteClick={onDeleteClick}
        loadingDelete={loadingDelete}
        profileData={profileData}
      />
    );
  });

  return (
    <SponsoredMessages>
      <BoxTitle>
        <TitleIcon>
          <img src={sponsoredMessagesIcon} style={{ width: "100%" }} />
        </TitleIcon>
        Sponsored Message
      </BoxTitle>
      <Text>
        The message is displayed to users who have no more posts available to
        view. Coins are not deducted for showing a sponsored message.{" "}
        <LearnMoreLinkWrap to="https://help.scalelup.com/en">
          Learn more
          <NewTabIcon>
            <img src={newTabIcon} style={{ width: "100%" }} />
          </NewTabIcon>
        </LearnMoreLinkWrap>
      </Text>
      <Messages>
        {list.length > 0 && (
          <>
            <ListTitle>Your Sponsored Messages</ListTitle>
            <MessageList>{list}</MessageList>
          </>
        )}
        {errorMessage && (
          <AdPlanWarning margintop="0">{errorMessage}</AdPlanWarning>
        )}
        <CreateFormButton>
          <ButtonPrimarySmallIcon
            icon={messageForm ? null : plusIcon}
            iconHover={plusWhiteIcon}
            onClick={toggleMessageForm}
          >
            {messageForm ? "Close" : "Create Message"}
          </ButtonPrimarySmallIcon>
        </CreateFormButton>
        <RollingBox>
          {messageForm && (
            <MessageForm>
              <InputWithLabel
                label="Message Text"
                width="100%"
                marginTop={css.VERTICAL_BOX_MARGIN}
                topRightContent={
                  <Counter
                    characters={messageInputs.text.length}
                    max={textMaxLength}
                  />
                }
              >
                <InputText
                  type="text"
                  name="text"
                  value={messageInputs.text}
                  placeholder="Enter message"
                  onChange={handleInputChange}
                  maxLength={textMaxLength}
                  warning={warnings.includes("text")}
                />
              </InputWithLabel>
              <InputWithLabel
                label="Link Text"
                width="100%"
                marginTop={css.VERTICAL_BOX_MARGIN_MEDIUM}
                tip="Enter the text for the link that will direct users to your website."
                tipId="linkText"
                topRightContent={
                  <Counter
                    characters={messageInputs.linkText.length}
                    max={linkTextMaxLength}
                  />
                }
              >
                <InputText
                  type="text"
                  name="linkText"
                  value={messageInputs.linkText}
                  placeholder="Enter link text"
                  onChange={handleInputChange}
                  maxLength={linkTextMaxLength}
                  warning={warnings.includes("linkText")}
                />
              </InputWithLabel>
              <InputWithLabel
                label="Link URL"
                width="100%"
                marginTop={css.VERTICAL_BOX_MARGIN_MEDIUM}
                tip="Enter the URL of the website you want to direct visitors to."
                tipId="linkUrl"
              >
                <InputText
                  type="text"
                  name="link"
                  value={messageInputs.link}
                  placeholder="https://..."
                  onChange={handleInputChange}
                  maxLength={400}
                  warning={warnings.includes("link")}
                />
              </InputWithLabel>
              <InputWithLabel
                label="Message Preview"
                width="100%"
                marginTop={css.VERTICAL_BOX_MARGIN_MEDIUM}
              >
                <PreviewWrap>
                  <SponsoredMessage
                    profileImage={profileData.profileImage}
                    username={profileData.username}
                    checkmark={profileData.adPlan}
                    text={messageInputs.text}
                    linkText={messageInputs.linkText}
                    link={messageInputs.link}
                    onLinkClick={(e) => e.preventDefault()}
                  />
                </PreviewWrap>
              </InputWithLabel>
              <SubmitButton>
                <ButtonPrimary
                  onClick={onMessageSubmit}
                  disabled={submitLoading}
                  minWidth="111px"
                >
                  {submitLoading ? <SmallSpinner /> : "Save"}
                </ButtonPrimary>
              </SubmitButton>
              {warnings.length !== 0 && (
                <Warning>
                  There are errors in the form. Please check the entered
                  information.
                </Warning>
              )}
              {submitError && <Warning>{submitError}</Warning>}
            </MessageForm>
          )}
        </RollingBox>
      </Messages>
      {messageToDelete && (
        <ModalWrap>
          <Backdrop
            onClick={closeDeleteModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <ConfirmDelete>
            <ModalWindow
              title="Delete Sponsored Message"
              handleModalClose={closeDeleteModal}
              fullScreenHeight={true}
            >
              <ConfirmDeleteWrap>
                <ConfirmDeleteText>
                  Do you really want to delete the message?
                </ConfirmDeleteText>
                <ConfirmDeleteButtons>
                  <ButtonWhite onClick={closeDeleteModal}>Cancel</ButtonWhite>
                  <ButtonPrimary onClick={onConfirmDelete}>
                    Delete
                  </ButtonPrimary>
                </ConfirmDeleteButtons>
              </ConfirmDeleteWrap>
            </ModalWindow>
          </ConfirmDelete>
        </ModalWrap>
      )}
      {editMessageModal && (
        <ModalWrap>
          <Backdrop
            onClick={closeEditMessageModal}
            background="rgba(0, 0, 0, 0.7)"
          />
          <ConfirmDelete>
            <ModalWindow
              title="Edit Sponsored Message"
              handleModalClose={closeEditMessageModal}
              fullScreenHeight={true}
            >
              <ConfirmDeleteWrap>
                <ConfirmDeleteText>
                  A sponsored message cannot be edited. Instead, create a new
                  one.
                </ConfirmDeleteText>
                <ConfirmDeleteButtons>
                  <ButtonWhite onClick={closeEditMessageModal}>
                    Close
                  </ButtonWhite>
                </ConfirmDeleteButtons>
              </ConfirmDeleteWrap>
            </ModalWindow>
          </ConfirmDelete>
        </ModalWrap>
      )}
    </SponsoredMessages>
  );
};
